import { createTheme } from "@mui/material/styles";

declare module "@mui/material/styles" {
	interface PaletteColor {
		"100"?: string;
		"300"?: string;
		"400"?: string;
		"500"?: string;
		"600"?: string;
		"700"?: string;
		"800"?: string;
	}
}

const theme = createTheme({
	palette: {
		mode: "light",
		text: {
			primary: "#282828",
		},
		primary: {
			contrastText: "#fff",
			main: "#0eb8ae",
			dark: "#0eb8ae",
			light: "#0eb8ae",
			"100": "#82dfd8",
			"300": "#2ae6d9",
			"400": "#10d4c7",
			"500": "#0eb8ae",
			"600": "#0ca096",
			"700": "#0a6963",
			"800": "#09746c",
		},
		secondary: {
			main: "#EBF4F9",
			"100": "#F5FBFF",
		},
		action: {
			hover: "#EBF4F9",
		},
		error: {
			main: "#D63657",
			dark: "#D63657",
			light: "#D63657",
			"100": "#FBEAED",
			"300": "#E58095",
			"400": "#611424",
			"500": "#D6365722",
		},
		success: {
			main: "#4EAA79",
			dark: "#4EAA79",
			light: "#4EAA79",
			"600": "#399238",
		},
		background: {
			default: "#ECEDED",
		},
	},
	typography: {
		fontFamily: ["Inter", "Roboto"].join(","),
		fontSize: 14,
		fontWeightRegular: 400,
		caption: {
			fontFamily: "Inter",
			fontWeight: 400,
			fontSize: 14,
			color: "#000",
		},
		subtitle1: {
			fontWeight: 400,
			color: "#000",
		},
	},
});

export default theme;
